import { Conditional } from '@opallabs/kuiper'
import { Link } from '@opallabs/lapidary'
import * as styles from './styles'

type PreviewPaneProps = {
  isEditing?: boolean
  url?: string
}

const SERVICE_LINKS = [
  {
    href: 'https://help.figma.com/hc/en-us/articles/360039827134-Embed-files-and-prototypes#files',
    text: 'Figma / Figjam',
  },
  {
    href: 'https://www.canva.com/help/embed-designs/',
    text: 'Canva',
  },
  {
    href: 'https://help.miro.com/hc/en-us/articles/360016335640-How-to-embed-Miro-boards#h_01HB8N4HRBB0W044NAZ6KFAQQG',
    text: 'Miro',
  },
  {
    href: 'https://support.google.com/docs/answer/183965',
    text: 'Google Docs / Sheets',
  },
  {
    href: 'https://support.microsoft.com/en-us/office/embed-files-directly-into-your-website-or-blog-ed07dd52-8bdb-431d-96a5-cbe8a80b7418',
    text: 'Microsoft 365 / OneDrive / Sharepoint',
  },
  {
    href: 'https://support.apple.com/guide/keynote-icloud/post-presentations-in-a-blog-gil617011364/icloud',
    text: 'Apple Keynote',
  },
  { href: 'https://www.dropbox.com/features/share', text: 'Dropbox' },
  {
    href: 'https://support.box.com/hc/en-us/articles/360043695434-Create-a-Box-Embed-Widget',
    text: 'Box',
  },
  { href: 'https://support.google.com/youtube/answer/171780', text: 'YouTube' },
  {
    href: 'https://help.vimeo.com/hc/en-us/articles/12426259908881-How-do-I-embed-my-video',
    text: 'Vimeo',
  },
  {
    href: 'https://support.loom.com/hc/en-us/articles/360002208317-How-to-embed-your-video-into-a-webpage',
    text: 'Loom',
  },
  {
    href: 'https://help.frame.io/en/articles/9105232-shares-in-frame-io',
    text: 'Frame.io',
  },
]

const PreviewPane: React.FC<PreviewPaneProps> = ({
  isEditing = true,
  url = '',
}) => {
  return (
    <div css={styles.container}>
      <Conditional condition={url.length > 0}>
        <iframe
          width="900"
          height="700"
          src={url}
          allowFullScreen={true}
          css={styles.iframe}
          title="Embedded Content"
          aria-label="Embedded Content"
          sandbox="allow-scripts allow-forms allow-presentation allow-same-origin allow-popups"
        ></iframe>
      </Conditional>

      <Conditional condition={isEditing && url.length == 0}>
        <div css={styles.infoContainer} aria-label="Embed Content Instructions">
          <h1 css={styles.headline}>Embed Content</h1>
          <p css={styles.text}>
            Opal supports pasting the embed code or URL from the services listed
            below.{' '}
            <button
              css={styles.contactUs}
              onClick={() => window.Intercom?.('show')}
            >
              Contact us
            </button>{' '}
            to request other services.
          </p>
          <ul css={styles.servicesWrapper}>
            {SERVICE_LINKS.map((link, index) => (
              <li key={index} css={styles.service}>
                <Link href={link.href} target="_blank">
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </Conditional>
    </div>
  )
}

export default PreviewPane
